import React, { useState, useEffect } from 'react';
import {
  EduAgentRenderer,
  PageSelectRenderer,
  InputTagRenderer,
  SwitchRenderer,
  TdSwitchRenderer,
  SelectRenderer,
  MulSelectRenderer,
  RadioRenderer,
  InputRenderer,
  InputNumberRenderer,
  RecognizeAgentTaskTypeRenderer
} from './renderers';

/**
 * 输入参数组件
 * 根据 params.type 渲染不同类型的表单控件
 */
function InputParams({
  rectOptions,
  clipImg,
  params,
  value,
  onChange,
  showClose = false,
  placeholder = '请输入',
  onClose,
  onSelect,
  advancedConfigValue = false,
  allParamsValue,
  isPdf,
  onParamsChange
}) {
  const [tags, setTags] = useState([]);
  const [currentKey, setCurrentKey] = useState(null);
  const [defaultTags, setDefaultTags] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pageSelectType, setPageSelectType] = useState('1');
  const [pageNumber, setPageNumber] = useState(1);
  const [inputPageNumber, setInputPageNumber] = useState(1);
  const [eduValue, setEduValue] = useState(null);

  useEffect(() => {
    if (params?.type === 'inputTag' && value) {
      setTags(value?.map((item) => item.KeyName));
      setDefaultTags(params?.default?.map((item) => item.KeyName));
    } else if (params?.type === 'pageSelect') {
      if (value) {
        setPageSelectType('2');
        setPageNumber(value);
      } else {
        setPageSelectType('1');
        setPageNumber(0);
      }
    }
  }, [params]);

  // TODO: 默认选中某张图
  useEffect(() => {
    if (clipImg) {
      setEduValue(clipImg?.curRect);
    } else {
      setEduValue(null);
    }
  }, [clipImg, rectOptions]);

  useEffect(() => {
    if (params?.type === 'inputTag' && value) {
      setTags(value?.map((item) => item.KeyName));
    } else if (params?.type === 'input-number') {
      setInputPageNumber(value);
    }
  }, [value]);

  const renderParams = () => {
    switch (params?.type) {
      case 'eduAgent':
        return (
          <EduAgentRenderer
            rectOptions={rectOptions}
            eduValue={eduValue}
            setEduValue={setEduValue}
            onSelect={onSelect}
          />
        );

      case 'pageSelect':
        return (
          <PageSelectRenderer
            params={params}
            pageSelectType={pageSelectType}
            setPageSelectType={setPageSelectType}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            onChange={onChange}
          />
        );

      case 'inputTag':
        return (
          <InputTagRenderer
            params={params}
            value={value}
            tags={tags}
            defaultTags={defaultTags}
            currentKey={currentKey}
            setCurrentKey={setCurrentKey}
            showConfirm={showConfirm}
            setShowConfirm={setShowConfirm}
            onChange={onChange}
            useAdvanced={advancedConfigValue}
          />
        );

      case 'switch':
        return (
          <SwitchRenderer
            params={params}
            value={value}
            onChange={onChange}
          />
        );

      case 'tdSwitch':
        return (
          <TdSwitchRenderer
            params={params}
            value={value}
            onChange={onChange}
          />
        );

      case 'select':
        return (
          <SelectRenderer
            params={params}
            value={value}
            showClose={showClose}
            onClose={onClose}
            onChange={onChange}
          />
        );

      case 'mulSelect':
        return (
          <MulSelectRenderer
            params={params}
            value={value}
            showClose={showClose}
            onClose={onClose}
            onChange={onChange}
          />
        );

      case 'radio':
        return (
          <RadioRenderer
            params={params}
            value={value}
            onChange={onChange}
          />
        );

      case 'input':
        return (
          <InputRenderer
            params={params}
            value={value}
            showClose={showClose}
            placeholder={placeholder}
            onClose={onClose}
            onChange={onChange}
          />
        );

      case 'input-number':
        return (
          <InputNumberRenderer
            params={params}
            inputPageNumber={inputPageNumber}
            onChange={onChange}
          />
        );

      case 'recognizeAgentTaskType':
        return (
          <RecognizeAgentTaskTypeRenderer
            params={params}
            value={value}
            onChange={onChange}
            allParamsValue={allParamsValue}
            onParamsChange={onParamsChange}
            isPdf={isPdf}
          />
        );

      default:
        return null;
    }
  };

  return <>{renderParams()}</>;
}

export default InputParams;
